import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { CfopsComponent } from './cfops.component';
import { CfopEditComponent } from './cfops-edit/cfop-edit.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
  ],
  declarations: [CfopsComponent,CfopEditComponent]
})
export class CfopsModule { }
